<template>
  <section class="auth">
    <form class="auth__card" @submit.prevent="forgot()">
      <h1 class="auth__title">Reset password</h1>
      <p class="auth__lede">We will email you a link to choose a new password.</p>

      <b-field label="Email">
        <b-input v-model.trim="email" type="email" placeholder="Your email" autocomplete="email" required></b-input>
      </b-field>

      <button type="submit" class="tb-btn" :disabled="loading">
        {{ loading ? "Sending..." : "Send Email" }}
      </button>

      <router-link class="auth__link" to="/login">Back to login</router-link>
    </form>
  </section>
</template>

<script>
  export default {
    name: "Forgot",
    data() {
      return {
        email: "",
        loading: false
      };
    },
    methods: {
      async forgot() {
        if (!this.email) return;
        this.loading = true;
        try {
          await this.$store.dispatch("forgot", this.email);
          this.$buefy.toast.open({ message: `Email has been sent to ${this.email}`, type: "is-success" });
        } catch (error) {
          this.$buefy.toast.open({ message: error.message, type: "is-danger" });
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped>
  .auth {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px 16px calc(24px + env(safe-area-inset-bottom, 0px));
    background: #1f2430;
  }

  .auth__card {
    width: 100%;
    max-width: 380px;
    padding: 22px;
    border-radius: var(--tb-radius);
    background: var(--tb-surface);
    box-shadow: var(--tb-shadow-lg);
    text-align: left;
  }

  .auth__title {
    margin: 0 0 6px;
    font-size: 22px;
  }

  .auth__lede {
    margin: 0 0 18px;
    color: var(--tb-ink-soft);
    font-size: 13px;
    font-weight: 400;
  }

  .auth__card .tb-btn {
    margin-top: 18px;
  }

  .auth__link {
    display: block;
    margin-top: 14px;
    font-size: 13px;
    text-align: center;
  }
</style>
